import {
    getUsers,
    deleteUser,
    createUser,
    updateUser,
    getAllUsers
} from '../../../services/UsersService';
import {
    CONFIRMED_GET_USERS,
    CONFIRMED_DELETE_USER_ACTION
} from './UserTypes';

export function deleteUserAction(userId, history) {
    return (dispatch, getState) => {
        return deleteUser(userId).then((response) => {
            return response;
        });
    };
}

export function confirmedDeleteUserAction(userId) {
    return {
        type: CONFIRMED_DELETE_USER_ACTION,
        payload: userId,
    };
}

export function getUsersAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_USERS_LOADING', payload: true });
        getUsers(currentPage, pageSize, searchTerm, filterQuery).then((response) => {
            dispatch(confirmedGetUsersAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'SET_USERS_LOADING', payload: false });
        });
    };
}

export function getAllUsersAction(filterQuery) {
    return (dispatch, getState) => {
        getAllUsers(filterQuery).then((response) => {
            dispatch(confirmedGetUsersAction(response.data.data));
        });
    };
}

export function confirmedGetUsersAction(users) {
    return {
        type: CONFIRMED_GET_USERS,
        payload: users,
    };
}

export function createUserAction(userData) {
    return () => {
        return createUser(userData).then((response) => {
            return response;
        });
    };
}

export function updateUserAction(userId, updatedData) {
    return () => {
        return updateUser(userId, updatedData).then((response) => {
            return response;
        });
    };
}

